module.exports = __webpack_public_path__ + "static/media/Cafe_2.ff25b782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_2.png
// module id = 1320
// module chunks = 3